import actionTypes from "../action-types/meta";

export function setCourseId(courseId: string) {
  return {
    type: actionTypes.SET_COURSE_ID,
    payload: {
      courseId
    }
  };
}

export function openShareTopicModal() {
  return {
    type: actionTypes.OPEN_SHARE_TOPIC_MODAL
  };
}

export function closeShareTopicModal() {
  return {
    type: actionTypes.CLOSE_SHARE_TOPIC_MODAL
  };
}

export function quitSession(
  courseId?: string | null | undefined,
  sectionId?: string | null | undefined
) {
  return {
    type: actionTypes.QUIT_SESSION,
    payload: {
      courseId,
      sectionId
    }
  };
}
